import { CLASSROOM_MODULE_LEAVE_WITHOUT_SAVING } from '../actions';
import fetchSections from './fetchSections.operation';

const leaveWithoutSaving = (destinationPath, keepEditing) => (
  dispatch,
  getState
) => {
  dispatch({
    type: CLASSROOM_MODULE_LEAVE_WITHOUT_SAVING,
    payload: {
      destinationPath,
      keepEditing,
    },
  });
  if (keepEditing === false) {
    dispatch(fetchSections(getState().classRoom.current));
  }
};

export default leaveWithoutSaving;
